/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_DetailsInputs */

const en_read_along_ai_details = /** @type {(inputs: Read_Along_Ai_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generation details`)
};

const es_read_along_ai_details = /** @type {(inputs: Read_Along_Ai_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles de la generación`)
};

/**
* | output |
* | --- |
* | "Generation details" |
*
* @param {Read_Along_Ai_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_details = /** @type {((inputs?: Read_Along_Ai_DetailsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_DetailsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_details(inputs)
	return en_read_along_ai_details(inputs)
});